import ChevronDownIcon from '../Icon/ChevronDownIcon.js';
import ChevronUpIcon from '../Icon/ChevronUpIcon.js';

//
var script = {
  components: {
    ChevronDownIcon,
    ChevronUpIcon
  },
  props: {
    column: {
      type: Object,
      required: true
    },
    stickyHeader: {
      type: Boolean,
      default: false
    },
    stickyLeft: {
      type: Boolean,
      default: false
    },
    stickyRight: {
      type: Boolean,
      default: false
    },
    sorted: {
      type: Boolean,
      default: false
    },
    sortedDesc: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      if (this.column.sortable) {
        this.$emit('sorted');
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/TableHeaderCell.vue_rollup-plugin-vue=script.js